import { useState, useEffect, useRef } from 'react';

export const useNavigation = (ready = true, initialHash = window.location.hash) => {
  const requestedHash = useRef(initialHash);
  const [currentSection, setCurrentSection] = useState('');

  useEffect(() => {
    if (!ready) return;
    let listening = false;
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 3;
      document.querySelectorAll<HTMLElement>('.lesson-section').forEach(section => {
        if (scrollPosition >= section.offsetTop && scrollPosition < section.offsetTop + section.offsetHeight) {
          setCurrentSection(section.id);
          if (window.location.hash !== `#${section.id}`) {
            window.history.replaceState(window.history.state, '', `#${section.id}`);
          }
        }
      });
    };
    // Wait for asynchronous lesson content and textarea sizing before restoring the day.
    const frame = requestAnimationFrame(() => {
      const sections = Array.from(document.querySelectorAll<HTMLElement>('.lesson-section'));
      const requested = sections.find(section => `#${section.id}` === requestedHash.current);
      const today = new Date().getDay();
      const fallbackId = today === 6 ? 'heading' : String(today + 1);
      const target = requested ?? sections.find(section => section.id === fallbackId) ?? sections[0];
      if (target) {
        target.scrollIntoView({ behavior: 'auto' });
        setCurrentSection(target.id);
        window.history.replaceState(window.history.state, '', `#${target.id}`);
      }
      window.addEventListener('scroll', handleScroll);
      listening = true;
    });
    return () => {
      cancelAnimationFrame(frame);
      if (listening) window.removeEventListener('scroll', handleScroll);
    };
  }, [ready]);

  return { currentSection };
};
